import { NotificationPreferenceInterface, UserPreferencesInterface } from "types/interfaces";
import { FrontEndModel } from "../FrontEndModel";

export class UserPreferenceModel extends FrontEndModel implements UserPreferencesInterface {
	notificationPreference: NotificationPreferenceInterface;
}